import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { BarChart as BarChartIcon, Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

function CollectionBanner({ onInsightsClick, onAddToyClick }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: 320, md: 420 },
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        backgroundImage: 'url(/banner.jfif)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(115deg, rgba(15, 23, 42, 0.78) 0%, rgba(99, 102, 241, 0.78) 55%, rgba(139, 92, 246, 0.55) 100%)'
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            color: 'white',
            textShadow: '0 6px 18px rgba(0,0,0,0.35)'
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '3rem' },
              mb: 1,
              textShadow: '0 4px 14px rgba(0,0,0,0.45)'
            }}
          >
            {t('collection.title')}
          </Typography>
          
          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              fontSize: { xs: '1rem', md: '1.25rem' },
              mb: 4,
              opacity: 0.92,
              textShadow: '0 3px 12px rgba(0,0,0,0.4)'
            }}
          >
            {t('collection.summary.title')}
          </Typography>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}
          >
            <Button
              variant="contained"
              startIcon={<BarChartIcon />}
              onClick={onInsightsClick}
              sx={{
                bgcolor: 'rgba(255, 255, 255, 0.22)',
                color: 'white',
                px: 3,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: 2,
                textTransform: 'none',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255,255,255,0.35)',
                boxShadow: '0 6px 18px rgba(0,0,0,0.3)',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.32)'
                }
              }}
            >
              {t('nav.insights')}
            </Button>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onAddToyClick}
              sx={{
                bgcolor: 'white',
                color: '#6366f1',
                px: 3,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: '0 10px 26px rgba(0,0,0,0.2)',
                '&:hover': {
                  bgcolor: '#f9f9f9'
                }
              }}
            >
              {t('collection.addNewToy')}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default CollectionBanner;
